// Components==============
import React from 'react';

import './AnimationLayer.module.scss';
import WaterfallBubbles from './components/WaterfallBubbles';
import Clouds from './components/Clouds';
import Cars from './components/Cars';
import AirBalloons from './components/AirBalloons';
import Boats from './components/Boats';
import WaterFall from './components/WaterFall';

// =========================

export default function AnimationLayer() {
    return (
        <>
            <svg
                styleName="background animationlayer"
                id="Animation_layer"
                data-name="Animation layer"
                xmlns="http://www.w3.org/2000/svg"
                width="7947.76"
                height="4100.22"
                viewBox="0 0 7947.76 4100.22"
            >
                <g id="omgeving_beweging" data-name="omgeving beweging">
                    <Clouds />
                    <WaterFall />
                    <WaterfallBubbles />
                </g>
                <g id="Animationlayer">
                    <Cars />
                    <AirBalloons />
                    <Boats />
                </g>
            </svg>
        </>
    );
}
